// src/characterLimits.js

const characterLimits = {
    name: 50,
    title: 100,
    location: 100,
    email: 50,
    phone: 20,
    summary: 1500,
    experience: 1000,
    skills: 300,
    education: 500,
    publications: 500,
    coverLetter: 2500,
};

export default characterLimits;
